import React, { useState, useEffect } from "react";
import "./CalculatorLeft.css";
import Select from "react-select";
import {
  authenticationCosts,
  countries,
  marketingCosts,
  serviceCosts,
  utilityCosts,
} from "./Data/DataCalculadora";

const CalculatorLeft = () => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedDivisa, setSelectedDivisa] = useState({
    value: "USD",
    label: "Dolar",
  });
  const [costoMarketing, setCostoMarketing] = useState(null);
  const [cantidadMarketing, setCantidadMarketing] = useState(0);
  const [totalMarketing, setTotalMarketing] = useState(null);
  const [costoUtility, setCostoUtility] = useState(null);
  const [cantidadUtility, setCantidadUtility] = useState(0);
  const [totalUtility, setTotalUtility] = useState(null);
  const [costoAuthentication, setCostoAuthentication] = useState(null);
  const [cantidadAuthentication, setCantidadAuthentication] = useState(0);
  const [totalAuthentication, setTotalAuthentication] = useState(null);
  const [costoServicio, setCostoServicio] = useState(null);
  const [cantidadServicio, setCantidadServicio] = useState(0);
  const [totalServicio, setTotalServicio] = useState(null);
  const [tooltipPositionMarketing, setTooltipPositionMarketing] = useState({});
  const [tooltipPositionUtility, setTooltipPositionUtility] = useState({});
  const [tooltipPositionAuthentication, setTooltipPositionAuthentication] =
    useState({});
  const [tooltipPositionServicio, setTooltipPositionServicio] = useState({});
  const [totalEstimado, setTotalEstimado] = useState(0);

  const divisas = [
    { value: "USD", label: "Dolar" },
    { value: "EUR", label: "Euro" },
  ];

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((response) => response.json())
      .then((data) => {
        const userCountry = data.country_name;
        const foundCountry = countries.find(
          (country) => country.label === userCountry
        );
        if (foundCountry) {
          setSelectedCountry(foundCountry);
          setCostoMarketing(
            marketingCosts[selectedDivisa.value][foundCountry.value]
          );
          setCostoUtility(
            utilityCosts[selectedDivisa.value][foundCountry.value]
          );
          setCostoAuthentication(
            authenticationCosts[selectedDivisa.value][foundCountry.value]
          );
          setCostoServicio(
            serviceCosts[selectedDivisa.value][foundCountry.value]
          );
        } else {
          setSelectedCountry({ value: "other", label: "Other" });
          setCostoMarketing(marketingCosts[selectedDivisa.value].other);
          setCostoUtility(utilityCosts[selectedDivisa.value].other);
          setCostoAuthentication(authenticationCosts[selectedDivisa.value].other);
          setCostoServicio(serviceCosts[selectedDivisa.value].other);
        }
      })
      .catch((error) => {
        console.error("Error fetching user country:", error);
        setSelectedCountry(null);
      });
  }, []);
  
  useEffect(() => {
    if (selectedCountry) {
      const newCostMarketing =
        marketingCosts[selectedDivisa.value][selectedCountry.value] || 0;
      const newCostUtility =
        utilityCosts[selectedDivisa.value][selectedCountry.value] || 0;
      const newCostAuthentication =
        authenticationCosts[selectedDivisa.value][selectedCountry.value] || 0;
      const newCostServicio =
        serviceCosts[selectedDivisa.value][selectedCountry.value] || 0;
  
      setCostoMarketing(newCostMarketing.toFixed(4));
      setCostoUtility(newCostUtility.toFixed(4));
      setCostoAuthentication(newCostAuthentication.toFixed(4));
      setCostoServicio(newCostServicio.toFixed(4));
  
      setTotalMarketing((cantidadMarketing * newCostMarketing).toFixed(4));
      setTotalUtility((cantidadUtility * newCostUtility).toFixed(4));
      setTotalAuthentication((cantidadAuthentication * newCostAuthentication).toFixed(4));
      setTotalServicio((cantidadServicio * newCostServicio).toFixed(4));
    }
  }, [selectedDivisa, selectedCountry]);
  
  useEffect(() => {
    if (
      totalMarketing !== null &&
      totalUtility !== null &&
      totalAuthentication !== null &&
      totalServicio !== null
    ) {
      const totalEstimado =
        parseFloat(totalMarketing) +
        parseFloat(totalUtility) +
        parseFloat(totalAuthentication) +
        parseFloat(totalServicio);
      setTotalEstimado(totalEstimado.toFixed(2));
    }
  }, [totalMarketing, totalUtility, totalAuthentication, totalServicio]);

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    const newCostMarketing =
      marketingCosts[selectedDivisa.value][selectedOption.value] || 0;
    setCostoMarketing(newCostMarketing.toFixed(4));
    setTotalMarketing((cantidadMarketing * newCostMarketing).toFixed(4));
    const newCostUtility =
      utilityCosts[selectedDivisa.value][selectedOption.value] || 0;
    setCostoUtility(newCostUtility.toFixed(4));
    setTotalUtility((cantidadUtility * newCostUtility).toFixed(4));
    const newCostAuthentication =
      authenticationCosts[selectedDivisa.value][selectedOption.value] || 0;
    setCostoAuthentication(newCostAuthentication.toFixed(4));
    setTotalAuthentication(
      (cantidadAuthentication * newCostAuthentication).toFixed(4)
    );
    const newCostServicio =
      serviceCosts[selectedDivisa.value][selectedOption.value] || 0;
    setCostoServicio(newCostServicio.toFixed(4));
    setTotalServicio((cantidadServicio * newCostServicio).toFixed(4));
  };

  const handleDivisaChange = (selectedOption) => {
    setSelectedDivisa(selectedOption);
  };

  const handleCostMarketingChange = (e) => {
    const newValue = Number(e.target.value);
    setCantidadMarketing(newValue);
    setTotalMarketing((newValue * costoMarketing).toFixed(4));

    const newPosition = {
      left: `${(newValue / 10000) * 100}%`,
    };
    setTooltipPositionMarketing(newPosition);
  };
  const handleCostUtilityChange = (e) => {
    const newValue = Number(e.target.value);
    setCantidadUtility(newValue);
    setTotalUtility((newValue * costoUtility).toFixed(4));

    const newPosition = {
      left: `${(newValue / 10000) * 100}%`,
    };
    setTooltipPositionUtility(newPosition);
  };
  const handleCostAuthenticationChange = (e) => {
    const newValue = Number(e.target.value);
    setCantidadAuthentication(newValue);
    setTotalAuthentication((newValue * costoAuthentication).toFixed(4));

    const newPosition = {
      left: `${(newValue / 10000) * 100}%`,
    };
    setTooltipPositionAuthentication(newPosition);
  };
  const handleCostServiceChange = (e) => {
    const newValue = Number(e.target.value);
    setCantidadServicio(newValue);
    setTotalServicio((newValue * costoServicio).toFixed(4));

    const newPosition = {
      left: `${(newValue / 10000) * 100}%`,
    };
    setTooltipPositionServicio(newPosition);
  };

  return (
    <div className="container-CalculatorLeft-Content">
      <div className="container-CalculatorLeft-container">
        <div className="container-CalculatorLeft-selectPaises">
          <label htmlFor="">
            Seleccione su país <i className="fa-solid fa-circle-info"></i>
          </label>
          <Select
            classNamePrefix="custom-select"
            options={countries}
            onChange={handleCountryChange}
            value={selectedCountry}
            placeholder="Selecciona un país..."
          />
          <span>
            Los países no mencionados en la lista se consideran "otros" países y
            están sujetos a las mismas tarifas.
          </span>
        </div>
        <div className="container-CalculatorLeft-selectDivisa">
          <Select
            classNamePrefix="custom-select"
            options={divisas}
            onChange={handleDivisaChange}
            value={selectedDivisa}
            placeholder="Selecciona una Divisa"
          />
        </div>
        <div className="container-CalculatorLeft-CategoriasContainer">
          <div className="container-CalculatorLeft-Categoria">
            <span> Conversación de marketing</span>
            <div className="container-CalculatorLeft-precio">
              <p>
                {" "}
                {selectedDivisa.value === "USD" ? "$" : "€"}
                {costoMarketing} / 24 horas
              </p>
              <output>
                {selectedDivisa.value === "USD" ? "$" : "€"}
                {totalMarketing}
              </output>
            </div>
            <div className="container-CalculatorLeft-cost">
              <input
                type="range"
                min={0}
                max={10000}
                value={cantidadMarketing}
                onChange={handleCostMarketingChange}
                className="range-slider"
              />
              <span
                className="tooltip"
                style={{ left: tooltipPositionMarketing.left }}
              >{`${cantidadMarketing}`}</span>
            </div>
          </div>
          <div className="container-CalculatorLeft-Categoria">
            <span> Conversación Utilitaria (Utility)</span>
            <div className="container-CalculatorLeft-precio">
              <p>
                {" "}
                {selectedDivisa.value === "USD" ? "$" : "€"}
                {costoUtility} / 24 horas
              </p>
              <output>
                {selectedDivisa.value === "USD" ? "$" : "€"}
                {totalUtility}
              </output>
            </div>
            <div className="container-CalculatorLeft-cost">
              <input
                type="range"
                min={0}
                max={10000}
                value={cantidadUtility}
                onChange={handleCostUtilityChange}
                className="range-slider"
              />
              <span
                className="tooltip"
                style={{ left: tooltipPositionUtility.left }}
              >{`${cantidadUtility}`}</span>
            </div>
          </div>
          <div className="container-CalculatorLeft-Categoria">
            <span> Conversación de autenticación (Authentication)</span>
            <div className="container-CalculatorLeft-precio">
              <p>
                {" "}
                {selectedDivisa.value === "USD" ? "$" : "€"}
                {costoAuthentication} / 24 horas
              </p>
              <output>
                {selectedDivisa.value === "USD" ? "$" : "€"}
                {totalAuthentication}
              </output>
            </div>
            <div className="container-CalculatorLeft-cost">
              <input
                type="range"
                min={0}
                max={10000}
                value={cantidadAuthentication}
                onChange={handleCostAuthenticationChange}
                className="range-slider"
              />
              <span
                className="tooltip"
                style={{ left: tooltipPositionAuthentication.left }}
              >{`${cantidadAuthentication}`}</span>
            </div>
          </div>
          <div className="container-CalculatorLeft-Categoria">
            <span> Conversación de Servicio</span>
            <div className="container-CalculatorLeft-precio">
              <p>
                {" "}
                {selectedDivisa.value === "USD" ? "$" : "€"}
                {costoServicio} / 24 horas
              </p>
              <output>
                {selectedDivisa.value === "USD" ? "$" : "€"}
                {totalServicio}
              </output>
            </div>
            <div className="container-CalculatorLeft-cost">
              <input
                type="range"
                min={0}
                max={10000}
                value={cantidadServicio}
                onChange={handleCostServiceChange}
                className="range-slider"
              />
              <span
                className="tooltip"
                style={{ left: tooltipPositionServicio.left }}
              >{`${cantidadServicio}`}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="container-CalculatorLeft-Estimado">
        <div className="container-CalculatorLeft-PrecioEstimado">
          <p>Estimación:</p>
          <output>
            {selectedDivisa.value === "USD" ? "$" : "€"}
            {totalEstimado}
          </output>
        </div>
        <div className="container-CalculatorLeft-Mensaje">
          <p>
            {" "}
            Para obtener más información sobre la estructura de precios de las
            conversaciones de WhatsApp, pongase{" "}
            <a href="https://api.whatsapp.com/message/MMX5O7MBCJBWE1?autoload=1&app_absent=0">en contacto con nosotros</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CalculatorLeft;
